"use strict";

var _classCallCheck = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var DocumentImpl = require("./Document-impl").implementation;

exports.implementation = /*#__PURE__*/function (_DocumentImpl) {
  _inherits(XMLDocumentImpl, _DocumentImpl);

  function XMLDocumentImpl() {
    _classCallCheck(this, XMLDocumentImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(XMLDocumentImpl).apply(this, arguments));
  }

  return XMLDocumentImpl;
}(DocumentImpl);